'use strict';

angular.module('mobile-apps').factory('MultiActionEntries', ['$resource',
    function($resource) {
        return $resource('/v1/projects/:mobileAppId/languages/:languageId/entries/groups/:groupId/action/:action',
            {
                mobileAppId: '@mobileAppId',
                languageId: '@languageId',
                groupId: '@groupId'
            },
            {
                lock: {
                    method:'PUT',
                    cache: false,
                    params :{action:'lock'},
                    isArray : false
                },
                lockAll: {
                    method:'PUT',
                    cache: false,
                    params :{action:'lockAll'},
                    isArray : false
                },
                unlock: {
                    method:'PUT',
                    cache: false,
                    params :{action:'unlock'},
                    isArray : false
                },
                unlockAll: {
                    method:'PUT',
                    cache: false,
                    params :{action:'unlockAll'},
                    isArray : false
                },
                publish: {
                    method:'PUT',
                    cache: false,
                    params :{action:'publish'},
                    isArray : false
                },
                clearDraft: {
                    method:'PUT',
                    cache: false,
                    params :{action:'clearDraft'},
                    isArray : false
                },
                clearValue: {
                    method:'PUT',
                    cache: false,
                    params :{action:'clearValue'},
                    isArray : false
                },
                delete: {
                    method:'PUT',
                    cache: false,
                    params :{action:'delete'},
                    isArray : false
                },
                link: {
                    method: 'PUT',
                    cache: false,
                    params: { action: 'link' },
                    isArray: false
                },
                unlink: {
                    method: 'PUT',
                    cache: false,
                    params: { action: 'unlink' },
                    isArray: false
                }
            }
        );
    }
]);
